import { Component, Input, OnInit } from '@angular/core';
import IZoningCodeRecord = ZoningAPI.IZoningCodeRecord;
import IZoningCodePRCountByZCStatusStatistic = ZoningAPI.IZoningCodePRCountByZCStatusStatistic;
import { ZoningCodeStatus, ZoningCodeStatusArray } from 'src/app/shared/enums/zoning-code-status';
import * as _ from 'lodash';

export interface IZoningCodePRCountByZCStatusStatisticExtended extends IZoningCodePRCountByZCStatusStatistic {
    zcvId: number;
}

import { formatNumber } from '@angular/common';

const defaultCountByZCStatus = Array(ZoningCodeStatusArray.length).fill(0);
const DEFAULT_ZCV_STATISTIC_BY_ZC_STATUS: IZoningCodePRCountByZCStatusStatisticExtended = {
    state: [].concat(defaultCountByZCStatus),
    county: [].concat(defaultCountByZCStatus),
    city: [].concat(defaultCountByZCStatus),
    total: [].concat(defaultCountByZCStatus),
    zcvId: null
};

@Component({
    standalone: false,
    selector: 'app-zoning-code-pr-cr-statistic',
    templateUrl: './zoning-code-pr-cr-statistic.component.html',
    styleUrls: ['./zoning-code-pr-cr-statistic.component.scss', '../../../../shared/styles/mdl-table.scss']
})
export class ZoningCodePrCrStatisticComponent implements OnInit {
    @Input()
    zoningCodeRecord: IZoningCodeRecord;

    zoningCodeStatus = ZoningCodeStatus;
    _zcvCRCountByZCStatus: IZoningCodePRCountByZCStatusStatisticExtended[];

    constructor() {}

    get zcvCRCountByZCStatus(): IZoningCodePRCountByZCStatusStatistic[] {
        if (!this.zoningCodeRecord) {
            return;
        }
        if (!this._zcvCRCountByZCStatus) {
            this._zcvCRCountByZCStatus = this.getzcvCRCountByZCStatus();
        }
        return this._zcvCRCountByZCStatus;
    }

    get hasZCVStatisticByZCStatusData(): boolean {
        return !!_.keys(_.get(this.zoningCodeRecord, 'MetaData.zcvIdCRCountByZCStatus', {})).length;
    }

    ngOnInit(): void {}

    getCountByStatusForZCVStr(
        zcvStat: IZoningCodePRCountByZCStatusStatistic,
        status: ZoningCodeStatus,
        dataSourceCategoryStr: string
    ) {
        return status
            ? `${formatNumber(_.get(zcvStat, `[${dataSourceCategoryStr}][${status}]`, 0) as number, 'en-US')}`
            : '0';
    }

    getzcvCRCountByZCStatus(): IZoningCodePRCountByZCStatusStatisticExtended[] {
        if (!this.zoningCodeRecord) {
            return null;
        }
        const zcvIdCRCountByZCStatus = _.get(this.zoningCodeRecord, 'MetaData.zcvIdCRCountByZCStatus');
        if (!zcvIdCRCountByZCStatus || !_.keys(zcvIdCRCountByZCStatus).length) {
            return [DEFAULT_ZCV_STATISTIC_BY_ZC_STATUS];
        }
        const result = [];
        _.forOwn(zcvIdCRCountByZCStatus, (stat, zcvId) => {
            result.push({ ...stat, zcvId });
        });
        return _.sortBy(result, ['isLatest', 'actualVersion', 'zcvId']);
    }
}
